// =============================================================
// Web entry — mounts the Perpetuum desktop/tablet console.
// Precompiled React (Vite, no in-browser Babel). Consumes @perpetuum/core +
// the real /api/v1 (proxied in dev). The localStorage prototype store is gone.
// =============================================================

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App.js";
import "./styles.css";

const el = document.getElementById("root");
if (!el) throw new Error("#root not found");

createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
